<template>
    <!--分页-->
        <div class="block" hide-on-single-page>
            <span class="demonstration"></span>
            <el-pagination
            @size-change="changeSizeFun"
            @current-change="changeCurrentFun"
            :current-page="pageData.pageindex"
            :page-sizes="[7,10, 20, 30, 50,100]"
            :page-size="pageData.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.count"
            ></el-pagination>
        </div>
</template>

<script>

export default {
   props:['pageData'],
    data() {
        return {
            
        }
    },
    methods:{
        //pagesize改变促发
        changeSizeFun(val){
            //调用父组件的方法--
            this.$emit('changeSizeFun',val)
        },
        //pageindex改变触发
        changeCurrentFun(val){
            //调用父组件的方法--
            this.$emit('changeCurrentFun',val)
        },
        
    }
}

</script>
